const shipments = [
    {
        departurePort: "Bremerhaven",
        destinations: [
            {
                destination: "USA",
                destinationPorts: [
                    {
                        port: "Long Beach",
                        shipments: [
                            {
                                vessel: "Auriga Leader",
                                initialETS: "01.01.",
                                latestETS: "06.01.",
                                departureDelay: 5,
                                plannedVolume: 700,
                                adjustedVolume: 1193,
                                stock: 2043,
                                shippingCapacityBottleneck: 850,
                                actualVolumeShipped: 1193,
                                initialETA: "23.01.",
                                actualETA: "01.02.",
                                arrivalDelay: 9,
                                arrivalActuals: 1193
                            },
                            {
                                vessel: "Dorado Leader",
                                initialETS: "20.01.",
                                latestETS: "25.01.",
                                departureDelay: 5,
                                plannedVolume: 1000,
                                adjustedVolume: 937,
                                stock: 2496,
                                shippingCapacityBottleneck: 1563,
                                actualVolumeShipped: 933,
                                initialETA: "13.02.",
                                actualETA: "19.02.",
                                arrivalDelay: 6,
                                arrivalActuals: 933
                            },
                            {
                                vessel: "Poseidon Leader",
                                initialETS: "02.02.",
                                latestETS: "03.02.",
                                departureDelay: 1,
                                plannedVolume: 1500,
                                adjustedVolume: 1600,
                                stock: 2633,
                                shippingCapacityBottleneck: 1038,
                                actualVolumeShipped: 1595,
                                initialETA: "27.02.",
                                actualETA: "27.02.",
                                arrivalDelay: 0,
                                arrivalActuals: 1595
                            },
                            {
                                vessel: "Grand Legacy",
                                initialETS: "04.02.",
                                latestETS: "10.02.",
                                departureDelay: 6,
                                plannedVolume: 1250,
                                adjustedVolume: 2204,
                                stock: 2552,
                                shippingCapacityBottleneck: 363,
                                actualVolumeShipped: 2189,
                                initialETA: "03.03.",
                                actualETA: "06.03.",
                                arrivalDelay: 3,
                                arrivalActuals: 2189
                            },
                            {
                                vessel: "Cassiopeia Leader",
                                initialETS: "19.02.",
                                latestETS: "26.02.",
                                departureDelay: 7,
                                plannedVolume: 900,
                                adjustedVolume: 764,
                                stock: 2028,
                                shippingCapacityBottleneck: 1304,
                                actualVolumeShipped: 724,
                                initialETA: "17.03.",
                                actualETA: "25.03.",
                                arrivalDelay: 8,
                                arrivalActuals: 724
                            },
                            {
                                vessel: "Grand Dolphin",
                                initialETS: "20.02.",
                                latestETS: "27.02.",
                                departureDelay: 7,
                                plannedVolume: 900,
                                adjustedVolume: 1120,
                                stock: 1365,
                                shippingCapacityBottleneck: 266,
                                actualVolumeShipped: 1099,
                                initialETA: "17.03.",
                                actualETA: "26.03.",
                                arrivalDelay: 9,
                                arrivalActuals: 1099
                            },
                            {
                                vessel: "Daedalus Leader",
                                initialETS: "03.03.",
                                latestETS: "07.03.",
                                departureDelay: 4,
                                plannedVolume: 1000,
                                adjustedVolume: 1120,
                                stock: 1876,
                                shippingCapacityBottleneck: 757,
                                actualVolumeShipped: 1119,
                                initialETA: "29.03.",
                                actualETA: "03.04.",
                                arrivalDelay: 5,
                                arrivalActuals: 1119
                            },
                            {
                                vessel: "Orion Leader",
                                initialETS: "09.03.",
                                latestETS: "14.03.",
                                departureDelay: 5,
                                plannedVolume: 1200,
                                adjustedVolume: 1390,
                                stock: 1942,
                                shippingCapacityBottleneck: 566,
                                actualVolumeShipped: 1376,
                                initialETA: "04.04.",
                                actualETA: "10.04.",
                                arrivalDelay: 6,
                                arrivalActuals: 1376
                            },
                            {
                                vessel: "Phoenix Leader",
                                initialETS: "22.03.",
                                latestETS: "28.03.",
                                departureDelay: 6,
                                plannedVolume: 1000,
                                adjustedVolume: 1000,
                                stock: 2746,
                                shippingCapacityBottleneck: 1760,
                                actualVolumeShipped: 986,
                                initialETA: "16.04.",
                                actualETA: "24.04.",
                                arrivalDelay: 8,
                                arrivalActuals: null
                            },
                            {
                                vessel: "Virgo Leader",
                                initialETS: "23.03.",
                                latestETS: "30.03.",
                                departureDelay: 7,
                                plannedVolume: 1000,
                                adjustedVolume: 1000,
                                stock: 2124,
                                shippingCapacityBottleneck: 1136,
                                actualVolumeShipped: 988,
                                initialETA: "17.04.",
                                actualETA: "26.04.",
                                arrivalDelay: 9,
                                arrivalActuals: null
                            },
                            {
                                vessel: "Glorious Leader",
                                initialETS: "02.04.",
                                latestETS: "04.04.",
                                departureDelay: 2,
                                plannedVolume: 1030,
                                adjustedVolume: 1265,
                                stock: 1860,
                                shippingCapacityBottleneck: 597,
                                actualVolumeShipped: 1263,
                                initialETA: "24.04.",
                                actualETA: "01.05.",
                                arrivalDelay: 7,
                                arrivalActuals: null
                            },
                            {
                                vessel: "Auriga Leader",
                                initialETS: "15.04.",
                                latestETS: "19.04.",
                                departureDelay: 4,
                                plannedVolume: 1300,
                                adjustedVolume: 1300,
                                stock: 2416,
                                shippingCapacityBottleneck: 1116,
                                actualVolumeShipped: null,
                                initialETA: "09.05.",
                                actualETA: "09.05.",
                                arrivalDelay: 0,
                                arrivalActuals: null
                            }

                        ]
                    },
                    {
                        port: "Brunswick",
                        shipments: [
                            {
                                vessel: "Donington",
                                initialETS: "27.12.",
                                latestETS: "12.01.",
                                departureDelay: 16,
                                plannedVolume: 900,
                                adjustedVolume: 750,
                                stock: 770,
                                shippingCapacityBottleneck: 78,
                                actualVolumeShipped: 692,
                                initialETA: "10.01.",
                                actualETA: "06.02.",
                                arrivalDelay: 27,
                                arrivalActuals: 692
                            },
                            {
                                vessel: "Themis",
                                initialETS: "14.01.",
                                latestETS: "14.01.",
                                departureDelay: 0,
                                plannedVolume: 31,
                                adjustedVolume: 31,
                                stock: 76,
                                shippingCapacityBottleneck: 45,
                                actualVolumeShipped: 31,
                                initialETA: "03.02.",
                                actualETA: "08.02.",
                                arrivalDelay: 5,
                                arrivalActuals: 31
                            },
                            {
                                vessel: "Elektra",
                                initialETS: "18.01.",
                                latestETS: "20.01.",
                                departureDelay: 2,
                                plannedVolume: 520,
                                adjustedVolume: 220,
                                stock: 329,
                                shippingCapacityBottleneck: 111,
                                actualVolumeShipped: 218,
                                initialETA: "03.02.",
                                actualETA: "08.02.",
                                arrivalDelay: 5,
                                arrivalActuals: 218
                            },
                            {
                                vessel: "ARC Independence",
                                initialETS: "19.01.",
                                latestETS: "24.01.",
                                departureDelay: 5,
                                plannedVolume: 150,
                                adjustedVolume: 216,
                                stock: 329,
                                shippingCapacityBottleneck: 116,
                                actualVolumeShipped: 213,
                                initialETA: "03.02.",
                                actualETA: "13.02.",
                                arrivalDelay: 10,
                                arrivalActuals: 213
                            },
                            {
                                vessel: "ARC Defender",
                                initialETS: "27.01.",
                                latestETS: "30.01.",
                                departureDelay: 3,
                                plannedVolume: 400,
                                adjustedVolume: 400,
                                stock: 900,
                                shippingCapacityBottleneck: 500,
                                actualVolumeShipped: 400,
                                initialETA: "17.02.",
                                actualETA: "22.02.",
                                arrivalDelay: 5,
                                arrivalActuals: 400
                            },
                            {
                                vessel: "Hawaiian Highway",
                                initialETS: "02.02.",
                                latestETS: "09.02.",
                                departureDelay: 7,
                                plannedVolume: 600,
                                adjustedVolume: 600,
                                stock: 785,
                                shippingCapacityBottleneck: 188,
                                actualVolumeShipped: 597,
                                initialETA: "18.02.",
                                actualETA: "28.02.",
                                arrivalDelay: 10,
                                arrivalActuals: 597
                            },
                            {
                                vessel: "Morning Courier",
                                initialETS: "15.02.",
                                latestETS: "16.02.",
                                departureDelay: -1,
                                plannedVolume: 500,
                                adjustedVolume: 120,
                                stock: 1081,
                                shippingCapacityBottleneck: 961,
                                actualVolumeShipped: 120,
                                initialETA: "14.03.",
                                actualETA: "18.03.",
                                arrivalDelay: 4,
                                arrivalActuals: 120
                            },
                            {
                                vessel: "Morning Cecilie",
                                initialETS: "24.02.",
                                latestETS: "24.02.",
                                departureDelay: 0,
                                plannedVolume: 500,
                                adjustedVolume: 679,
                                stock: 1916,
                                shippingCapacityBottleneck: 1244,
                                actualVolumeShipped: 672,
                                initialETA: "18.03.",
                                actualETA: "18.03.",
                                arrivalDelay: 0,
                                arrivalActuals: 672
                            },
                            {
                                vessel: "Victoria Highway",
                                initialETS: "16.02.",
                                latestETS: "25.02.",
                                departureDelay: 9,
                                plannedVolume: 1000,
                                adjustedVolume: 1000,
                                stock: 1313,
                                shippingCapacityBottleneck: 324,
                                actualVolumeShipped: 989,
                                initialETA: "04.03.",
                                actualETA: "17.03.",
                                arrivalDelay: 13,
                                arrivalActuals: 989
                            },
                            {
                                vessel: "Orion Highway",
                                initialETS: "22.02.",
                                latestETS: "28.02.",
                                departureDelay: 6,
                                plannedVolume: 200,
                                adjustedVolume: 400,
                                stock: 710,
                                shippingCapacityBottleneck: 310,
                                actualVolumeShipped: 400,
                                initialETA: "11.03.",
                                actualETA: "22.03.",
                                arrivalDelay: 11,
                                arrivalActuals: 400
                            },
                            {
                                vessel: "Grand Pavo",
                                initialETS: "28.02.",
                                latestETS: "03.03.",
                                departureDelay: -3,
                                plannedVolume: 500,
                                adjustedVolume: 1000,
                                stock: 1209,
                                shippingCapacityBottleneck: 234,
                                actualVolumeShipped: 975,
                                initialETA: "16.03.",
                                actualETA: "26.03.",
                                arrivalDelay: 10,
                                arrivalActuals: 975
                            },
                            {
                                vessel: "Arc Integrity",
                                initialETS: "24.03.",
                                latestETS: "25.03.",
                                departureDelay: -1,
                                plannedVolume: 500,
                                adjustedVolume: 200,
                                stock: 2125,
                                shippingCapacityBottleneck: 1929,
                                actualVolumeShipped: 196,
                                initialETA: "10.04.",
                                actualETA: "10.04.",
                                arrivalDelay: 0,
                                arrivalActuals: 196
                            },
                            {
                                vessel: "Arc Defender",
                                initialETS: "27.03.",
                                latestETS: "26.03.",
                                departureDelay: 1,
                                plannedVolume: 700,
                                adjustedVolume: 1300,
                                stock: 2126,
                                shippingCapacityBottleneck: 832,
                                actualVolumeShipped: 1294,
                                initialETA: "15.04.",
                                actualETA: "15.04.",
                                arrivalDelay: 0,
                                arrivalActuals: 1294
                            }
                        ]
                    },
                    {
                        port: "Baltimore",
                        shipments: [
                            {
                                vessel: "Resolve",
                                initialETS: "07.01.",
                                latestETS: "06.01.",
                                departureDelay: 1,
                                plannedVolume: 1330,
                                adjustedVolume: 1069,
                                stock: 1169,
                                shippingCapacityBottleneck: 144,
                                actualVolumeShipped: 1025,
                                initialETA: "18.01.",
                                actualETA: "23.01.",
                                arrivalDelay: 5,
                                arrivalActuals: 1025
                            },
                            {
                                vessel: "Carmen",
                                initialETS: "04.01.",
                                latestETS: "07.01.",
                                departureDelay: 3,
                                plannedVolume: 800,
                                adjustedVolume: 108,
                                stock: 111,
                                shippingCapacityBottleneck: 3,
                                actualVolumeShipped: 108,
                                initialETA: "31.01.",
                                actualETA: "31.01.",
                                arrivalDelay: 0,
                                arrivalActuals: 108
                            },
                            {
                                vessel: "Donington",
                                initialETS: "01.01.",
                                latestETS: "12.01.",
                                departureDelay: 11,
                                plannedVolume: 400,
                                adjustedVolume: 250,
                                stock: 274,
                                shippingCapacityBottleneck: 75,
                                actualVolumeShipped: 199,
                                initialETA: "09.01.",
                                actualETA: "30.01.",
                                arrivalDelay: 21,
                                arrivalActuals: 199
                            },
                            {
                                vessel: "Nabucco",
                                initialETS: "13.01.",
                                latestETS: "23.01.",
                                departureDelay: 10,
                                plannedVolume: 800,
                                adjustedVolume: 752,
                                stock: 925,
                                shippingCapacityBottleneck: 173,
                                actualVolumeShipped: 752,
                                initialETA: "02.02.",
                                actualETA: "06.02.",
                                arrivalDelay: 4,
                                arrivalActuals: 752
                            },
                            {
                                vessel: "Brooklands",
                                initialETS: "18.01.",
                                latestETS: "31.01.",
                                departureDelay: 13,
                                plannedVolume: 200,
                                adjustedVolume: 200,
                                stock: 944,
                                shippingCapacityBottleneck: 744,
                                actualVolumeShipped: 200,
                                initialETA: "30.01.",
                                actualETA: "14.02.",
                                arrivalDelay: 15,
                                arrivalActuals: 200
                            },
                            {
                                vessel: "Tannhauser",
                                initialETS: "25.01.",
                                latestETS: "02.02.",
                                departureDelay: 8,
                                plannedVolume: 400,
                                adjustedVolume: 700,
                                stock: 1046,
                                shippingCapacityBottleneck: 346,
                                actualVolumeShipped: 700,
                                initialETA: "16.02.",
                                actualETA: "25.02.",
                                arrivalDelay: 9,
                                arrivalActuals: 700
                            },
                            {
                                vessel: "Traviata",
                                initialETS: "05.02.",
                                latestETS: "08.02.",
                                departureDelay: 3,
                                plannedVolume: 500,
                                adjustedVolume: 700,
                                stock: 969,
                                shippingCapacityBottleneck: 269,
                                actualVolumeShipped: 700,
                                initialETA: "25.02.",
                                actualETA: "02.03.",
                                arrivalDelay: 5,
                                arrivalActuals: 700
                            },
                            {
                                vessel: "Hawaiian Highway",
                                initialETS: "02.02.",
                                latestETS: "09.02.",
                                departureDelay: 7,
                                plannedVolume: 200,
                                adjustedVolume: 500,
                                stock: 578,
                                shippingCapacityBottleneck: 80,
                                actualVolumeShipped: 498,
                                initialETA: "14.02.",
                                actualETA: "24.02.",
                                arrivalDelay: 10,
                                arrivalActuals: 498
                            },
                            {
                                vessel: "Tulane",
                                initialETS: "14.02.",
                                latestETS: "16.02.",
                                departureDelay: 2,
                                plannedVolume: 600,
                                adjustedVolume: 700,
                                stock: 1070,
                                shippingCapacityBottleneck: 388,
                                actualVolumeShipped: 682,
                                initialETA: "28.02.",
                                actualETA: "06.03.",
                                arrivalDelay: 6,
                                arrivalActuals: 682
                            },
                            {
                                vessel: "Donington",
                                initialETS: "17.02.",
                                latestETS: "20.02.",
                                departureDelay: 3,
                                plannedVolume: 300,
                                adjustedVolume: 300,
                                stock: 1086,
                                shippingCapacityBottleneck: 786,
                                actualVolumeShipped: 300,
                                initialETA: "01.03.",
                                actualETA: "10.03.",
                                arrivalDelay: 9,
                                arrivalActuals: 300
                            },
                            {
                                vessel: "Tonsberg",
                                initialETS: "15.02.",
                                latestETS: "24.02.",
                                departureDelay: 9,
                                plannedVolume: 800,
                                adjustedVolume: 550,
                                stock: 1446,
                                shippingCapacityBottleneck: 918,
                                actualVolumeShipped: 528,
                                initialETA: "06.03.",
                                actualETA: "16.03.",
                                arrivalDelay: 10,
                                arrivalActuals: 528
                            },
                            {
                                vessel: "Orion Highway",
                                initialETS: "22.02.",
                                latestETS: "28.02.",
                                departureDelay: 6,
                                plannedVolume: 400,
                                adjustedVolume: 1000,
                                stock: 1577,
                                shippingCapacityBottleneck: 577,
                                actualVolumeShipped: 1000,
                                initialETA: "07.03.",
                                actualETA: "20.03.",
                                arrivalDelay: 13,
                                arrivalActuals: 1000
                            },
                            {
                                vessel: "Oberon",
                                initialETS: "02.03.",
                                latestETS: "01.03.",
                                departureDelay: -1,
                                plannedVolume: 800,
                                adjustedVolume: 400,
                                stock: 927,
                                shippingCapacityBottleneck: 530,
                                actualVolumeShipped: 397,
                                initialETA: "20.03.",
                                actualETA: "28.03.",
                                arrivalDelay: 8,
                                arrivalActuals: 397
                              },
                              {
                                vessel: "Brooklands",
                                initialETS: "01.03.",
                                latestETS: "10.03.",
                                departureDelay: 9,
                                plannedVolume: 900,
                                adjustedVolume: 880,
                                stock: 2670,
                                shippingCapacityBottleneck: 1798,
                                actualVolumeShipped: 872,
                                initialETA: "15.03.",
                                actualETA: "29.03.",
                                arrivalDelay: 14,
                                arrivalActuals: 872
                              },
                              {
                                vessel: "Boheme",
                                initialETS: "18.03.",
                                latestETS: "18.03.",
                                departureDelay: 0,
                                plannedVolume: 800,
                                adjustedVolume: 1850,
                                stock: 4669,
                                shippingCapacityBottleneck: 2871,
                                actualVolumeShipped: 1798,
                                initialETA: "01.04.",
                                actualETA: "08.04.",
                                arrivalDelay: 7,
                                arrivalActuals: 1795
                              }
                        ]
                    }
                ]
            },
            {
                destination: "Canada",
                destinationPorts: [
                    {
                        port: "Halifax",
                        shipments: [
                            {
                                vessel: "Elektra",
                                initialETS: "18.01.",
                                latestETS: "21.01.",
                                departureDelay: 3,
                                plannedVolume: 1000,
                                adjustedVolume: 1300,
                                stock: 1708,
                                shippingCapacityBottleneck: 1006,
                                actualVolumeShipped: 702,
                                initialETA: "28.01.",
                                actualETA: "31.01.",
                                arrivalDelay: 3,
                                arrivalActuals: 702
                            },
                            {
                                vessel: "Morning Lena",
                                initialETS: "27.01.",
                                latestETS: "27.01.",
                                departureDelay: 0,
                                plannedVolume: 500,
                                adjustedVolume: 380,
                                stock: 376,
                                shippingCapacityBottleneck: -4,
                                actualVolumeShipped: 380,
                                initialETA: "12.02.",
                                actualETA: "13.02.",
                                arrivalDelay: 1,
                                arrivalActuals: 380
                            },
                            {
                                vessel: "Boheme",
                                initialETS: "11.02.",
                                latestETS: "07.02.",
                                departureDelay: -4,
                                plannedVolume: 300,
                                adjustedVolume: 496,
                                stock: 709,
                                shippingCapacityBottleneck: 216,
                                actualVolumeShipped: 493,
                                initialETA: "26.02.",
                                actualETA: "22.02.",
                                arrivalDelay: -4,
                                arrivalActuals: 493
                            },
                            {
                                vessel: "Traviata",
                                initialETS: "08.02.",
                                latestETS: "08.02.",
                                departureDelay: 0,
                                plannedVolume: 314,
                                adjustedVolume: 314,
                                stock: 389,
                                shippingCapacityBottleneck: 75,
                                actualVolumeShipped: 314,
                                initialETA: "20.02.",
                                actualETA: "23.02.",
                                arrivalDelay: 3,
                                arrivalActuals: 314
                            },
                            {
                                vessel: "Morning Courier",
                                initialETS: "16.02.",
                                latestETS: "16.02.",
                                departureDelay: 0,
                                plannedVolume: 300,
                                adjustedVolume: 100,
                                stock: 480,
                                shippingCapacityBottleneck: 380,
                                actualVolumeShipped: 100,
                                initialETA: "06.03.",
                                actualETA: "09.03.",
                                arrivalDelay: 3,
                                arrivalActuals: 100
                            }
                        ]
                    }
                ]
            }
        ]
    }
];

export { shipments };